import React from 'react';
import DialogConfirm from '../../dialog/dialog-confirm';
import { TDialog } from '../../dialog/dialog/index.types';
import { DialogWrapper } from '../index.styles';
import { EButtonType } from 'components/control/button/button.types';

const ApproveDialog = ({
                         isDialogOpen,
                         setIsDialogOpen,
                         title,
                         onSubmit,
                         kycId,
                       }: TDialog & { onSubmit: (id: string) => void; kycId: string }) => {
  return (
    <DialogConfirm
      isDialogOpen={isDialogOpen}
      setIsDialogOpen={setIsDialogOpen}
      title={title}
      onOk={() => onSubmit(kycId)}
      labels={{ onOk: 'Approve' }}
      buttonType={EButtonType.Primary}
    >
      <DialogWrapper>
        <p>{'Are you sure you want to approve this User KYC?'}</p>
      </DialogWrapper>
    </DialogConfirm>
  );
};

export default ApproveDialog;
